module.exports = __webpack_public_path__ + "static/media/company-icon.20e9df25.svg";